export default {
    WELCOME: "Добро пожаловать!",
    DESCRIPTION: "Создайте первое пространство",
    DESCRIPTION_NOT_EMPTY_WORKSPACES: "Выберите пространство из списка на левой панели или создайте новое",
    ADD_WORKSPACE: "Создать пространство"
};
